// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/event/v1/legacy_portal_service.proto (package spwn.event.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3 } from "@bufbuild/protobuf";
import { LegacyPortalEventGoods } from "./legacy_portal_common_pb";
/**
 * ウォッチリストに追加
 *
 * @generated from message spwn.event.v1.LegacyPortalEventServiceAddEventGoodsToWatchlistRequest
 */
export class LegacyPortalEventServiceAddEventGoodsToWatchlistRequest extends Message {
    constructor(data) {
        super();
        /**
         * イベントグッズのFirestore ID
         *
         * @generated from field: string event_goods_firestore_id = 1;
         */
        this.eventGoodsFirestoreId = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalEventServiceAddEventGoodsToWatchlistRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalEventServiceAddEventGoodsToWatchlistRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalEventServiceAddEventGoodsToWatchlistRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalEventServiceAddEventGoodsToWatchlistRequest, a, b);
    }
}
LegacyPortalEventServiceAddEventGoodsToWatchlistRequest.runtime = proto3;
LegacyPortalEventServiceAddEventGoodsToWatchlistRequest.typeName = "spwn.event.v1.LegacyPortalEventServiceAddEventGoodsToWatchlistRequest";
LegacyPortalEventServiceAddEventGoodsToWatchlistRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "event_goods_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.LegacyPortalEventServiceAddEventGoodsToWatchlistResponse
 */
export class LegacyPortalEventServiceAddEventGoodsToWatchlistResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalEventServiceAddEventGoodsToWatchlistResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalEventServiceAddEventGoodsToWatchlistResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalEventServiceAddEventGoodsToWatchlistResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalEventServiceAddEventGoodsToWatchlistResponse, a, b);
    }
}
LegacyPortalEventServiceAddEventGoodsToWatchlistResponse.runtime = proto3;
LegacyPortalEventServiceAddEventGoodsToWatchlistResponse.typeName = "spwn.event.v1.LegacyPortalEventServiceAddEventGoodsToWatchlistResponse";
LegacyPortalEventServiceAddEventGoodsToWatchlistResponse.fields = proto3.util.newFieldList(() => []);
/**
 * ウォッチリストから削除
 *
 * @generated from message spwn.event.v1.LegacyPortalEventServiceRemoveEventGoodsFromWatchlistRequest
 */
export class LegacyPortalEventServiceRemoveEventGoodsFromWatchlistRequest extends Message {
    constructor(data) {
        super();
        /**
         * イベントグッズのFirestore ID
         *
         * @generated from field: string event_goods_firestore_id = 1;
         */
        this.eventGoodsFirestoreId = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalEventServiceRemoveEventGoodsFromWatchlistRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalEventServiceRemoveEventGoodsFromWatchlistRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalEventServiceRemoveEventGoodsFromWatchlistRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalEventServiceRemoveEventGoodsFromWatchlistRequest, a, b);
    }
}
LegacyPortalEventServiceRemoveEventGoodsFromWatchlistRequest.runtime = proto3;
LegacyPortalEventServiceRemoveEventGoodsFromWatchlistRequest.typeName = "spwn.event.v1.LegacyPortalEventServiceRemoveEventGoodsFromWatchlistRequest";
LegacyPortalEventServiceRemoveEventGoodsFromWatchlistRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "event_goods_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.LegacyPortalEventServiceRemoveEventGoodsFromWatchlistResponse
 */
export class LegacyPortalEventServiceRemoveEventGoodsFromWatchlistResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalEventServiceRemoveEventGoodsFromWatchlistResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalEventServiceRemoveEventGoodsFromWatchlistResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalEventServiceRemoveEventGoodsFromWatchlistResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalEventServiceRemoveEventGoodsFromWatchlistResponse, a, b);
    }
}
LegacyPortalEventServiceRemoveEventGoodsFromWatchlistResponse.runtime = proto3;
LegacyPortalEventServiceRemoveEventGoodsFromWatchlistResponse.typeName = "spwn.event.v1.LegacyPortalEventServiceRemoveEventGoodsFromWatchlistResponse";
LegacyPortalEventServiceRemoveEventGoodsFromWatchlistResponse.fields = proto3.util.newFieldList(() => []);
/**
 * ユーザのウォッチリスト取得
 *
 * @generated from message spwn.event.v1.LegacyPortalEventServiceGetWatchlistEventGoodsRequest
 */
export class LegacyPortalEventServiceGetWatchlistEventGoodsRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalEventServiceGetWatchlistEventGoodsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalEventServiceGetWatchlistEventGoodsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalEventServiceGetWatchlistEventGoodsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalEventServiceGetWatchlistEventGoodsRequest, a, b);
    }
}
LegacyPortalEventServiceGetWatchlistEventGoodsRequest.runtime = proto3;
LegacyPortalEventServiceGetWatchlistEventGoodsRequest.typeName = "spwn.event.v1.LegacyPortalEventServiceGetWatchlistEventGoodsRequest";
LegacyPortalEventServiceGetWatchlistEventGoodsRequest.fields = proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.event.v1.LegacyPortalEventServiceGetWatchlistEventGoodsResponse
 */
export class LegacyPortalEventServiceGetWatchlistEventGoodsResponse extends Message {
    constructor(data) {
        super();
        /**
         * ウォッチリストに登録されているイベントグッズ一覧
         *
         * @generated from field: repeated spwn.event.v1.LegacyPortalEventGoods goods = 1;
         */
        this.goods = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalEventServiceGetWatchlistEventGoodsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalEventServiceGetWatchlistEventGoodsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalEventServiceGetWatchlistEventGoodsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalEventServiceGetWatchlistEventGoodsResponse, a, b);
    }
}
LegacyPortalEventServiceGetWatchlistEventGoodsResponse.runtime = proto3;
LegacyPortalEventServiceGetWatchlistEventGoodsResponse.typeName = "spwn.event.v1.LegacyPortalEventServiceGetWatchlistEventGoodsResponse";
LegacyPortalEventServiceGetWatchlistEventGoodsResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "goods", kind: "message", T: LegacyPortalEventGoods, repeated: true },
]);
/**
 * idを指定してイベントグッズを取得
 *
 * @generated from message spwn.event.v1.LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsRequest
 */
export class LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsRequest extends Message {
    constructor(data) {
        super();
        /**
         * イベントグッズのFirestore IDリスト
         *
         * @generated from field: repeated string event_goods_firestore_ids = 1;
         */
        this.eventGoodsFirestoreIds = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsRequest, a, b);
    }
}
LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsRequest.runtime = proto3;
LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsRequest.typeName = "spwn.event.v1.LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsRequest";
LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "event_goods_firestore_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * @generated from message spwn.event.v1.LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsResponse
 */
export class LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsResponse extends Message {
    constructor(data) {
        super();
        /**
         * 指定されたイベントグッズ一覧
         *
         * @generated from field: repeated spwn.event.v1.LegacyPortalEventGoods goods = 1;
         */
        this.goods = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsResponse, a, b);
    }
}
LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsResponse.runtime = proto3;
LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsResponse.typeName = "spwn.event.v1.LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsResponse";
LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "goods", kind: "message", T: LegacyPortalEventGoods, repeated: true },
]);
//# sourceMappingURL=legacy_portal_service_pb.js.map